import Image from "next/image";
import { FC } from "react";
import { descriptions } from "../../../model/utils";
import s from "./styles.module.sass";

const AboutSelfSchool: FC = () => {
	return (
		<section className={`${s.aboutSelfSchool} marginedSection`}>
			<h3>Selfschool - это...</h3>
			<ul className={s.descriptions}>
				{descriptions.map((description, index) => {
					return (
						<li key={index} className={s.description}>
							<div className={s.descriptionImage}>
								<Image src={description.icon} alt={description.title} />
							</div>
							<p className={s.descriptionTitle}>{description.title}</p>
						</li>
					);
				})}
			</ul>
			<div className={s.pinkPolygon} />
			<div className={s.lightBluePolygon} />
			<div className={s.yellowEllipse} />
		</section>
	);
};

export default AboutSelfSchool;
